export default __webpack_public_path__ + "static/cocaine-lockup-image-293fab12f01bfc807771a3dc39105326.jpg";